import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export class Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
};

export class AccessDashboard {
  createdAt: Scalars['String'];
  total: Scalars['Float'];
};

export class ActiveUsers {
  name: Scalars['String'];
  total: Scalars['Float'];
};

export class AnswerContactInput {
  answer: Scalars['String'];
  contactId: Scalars['String'];
};

export class AuthInput {
  email: Scalars['String'];
  password: Scalars['String'];
  /** admin|user */
  type?: InputMaybe<Scalars['String']>;
};

export class AuthType {
  token: Scalars['String'];
  user: User;
};

export class Banner {
  bannerAccess?: Maybe<Array<BannerAccess>>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  end?: Maybe<Scalars['DateTime']>;
  highlight?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  pathImage?: Maybe<Scalars['String']>;
  pathLink?: Maybe<Scalars['String']>;
  position: Scalars['Float'];
  profile?: Maybe<Scalars['String']>;
  scheduled: Scalars['Boolean'];
  start?: Maybe<Scalars['DateTime']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export class BannerAccess {
  banner?: Maybe<Banner>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  user?: Maybe<User>;
};

export class BannerDashboard {
  title?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Float']>;
};

export class BannerPage {
  banner: Array<Banner>;
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previousPage: Scalars['Boolean'];
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class CategoryDownload {
  download?: Maybe<Array<Download>>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export class ChangePasswordInput {
  newPassword: Scalars['String'];
  password: Scalars['String'];
};

export class Contact {
  answer?: Maybe<Scalars['String']>;
  answeredAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['ID'];
  message: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  subject: Subject;
  user?: Maybe<User>;
  userAdmin?: Maybe<User>;
};

export class ContactCount {
  noAnswered: Scalars['Float'];
  total: Scalars['Float'];
};

export class ContactPage {
  contact: Array<Contact>;
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previousPage: Scalars['Boolean'];
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class CreateBannerAccessInput {
  bannerId: Scalars['String'];
};

export class CreateBannerInput {
  end?: InputMaybe<Scalars['DateTime']>;
  highlight: Scalars['Boolean'];
  pathImage?: InputMaybe<Scalars['String']>;
  pathLink?: InputMaybe<Scalars['String']>;
  position: Scalars['Float'];
  scheduled: Scalars['Boolean'];
  start?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
};

export class CreateContactInput {
  answer?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  jobRole?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  profile?: InputMaybe<Scalars['String']>;
  subjectId: Scalars['String'];
};

export class CreateDownloadAccessInput {
  downloadId: Scalars['String'];
};

export class CreateDownloadInput {
  categoryId: Scalars['String'];
  extension?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  path: Scalars['String'];
  profile: Scalars['String'];
};

export class CreateNewsAccessInput {
  /** Id news */
  newsId: Scalars['String'];
};

export class CreateNewsInput {
  /** Description news */
  description?: InputMaybe<Scalars['String']>;
  /** Schedule date end */
  end?: InputMaybe<Scalars['DateTime']>;
  highlight?: InputMaybe<Scalars['Boolean']>;
  /** PathImage news */
  pathImage?: InputMaybe<Scalars['String']>;
  /** Schedule news */
  scheduled: Scalars['Boolean'];
  /** Schedule date start */
  start?: InputMaybe<Scalars['DateTime']>;
  /** Text news */
  text?: InputMaybe<Scalars['String']>;
  /** Title news */
  title: Scalars['String'];
  /** ENUM news|case|article|other */
  type: Scalars['String'];
};

export class CreateUserAdminInput {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
};

export class CreateUserInput {
  birthday?: InputMaybe<Scalars['String']>;
  cpf?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  jobRole?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};

export class DefaultMessage {
  message: Scalars['String'];
  status: Scalars['Int'];
};

export class Download {
  category?: Maybe<CategoryDownload>;
  createdAt: Scalars['DateTime'];
  downloadAccess?: Maybe<Array<DownloadAccess>>;
  extension?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  path?: Maybe<Scalars['String']>;
  profile: Scalars['String'];
};

export class DownloadAccess {
  createdAt: Scalars['DateTime'];
  download?: Maybe<Download>;
  id: Scalars['ID'];
  user: User;
};

export class DownloadDashboard {
  name?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Float']>;
};

export class DownloadPage {
  currentPage: Scalars['Int'];
  downloads: Array<Download>;
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previousPage: Scalars['Boolean'];
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class Mutation {
  answerContact: DefaultMessage;
  changePassword: DefaultMessage;
  clickBanner: DefaultMessage;
  clickDownload: DefaultMessage;
  clickNewsAccess: DefaultMessage;
  /** Create Admin */
  createAdmin: DefaultMessage;
  createBanner: Banner;
  createContact: DefaultMessage;
  createDownload: Download;
  createNews: News;
  /** Create User */
  createUser: TokenDto;
  /** Delete Admin */
  deleteAdmin: DefaultMessage;
  forgotPassword: DefaultMessage;
  login: AuthType;
  removeBanner: DefaultMessage;
  removeDownload: DefaultMessage;
  removeNews: DefaultMessage;
  resetPassword: DefaultMessage;
  /** Update User */
  selfUpdateUser: User;
  updateBanner: Banner;
  updateDownload: Download;
  updateNews: News;
};


export class MutationAnswerContactArgs {
  data: AnswerContactInput;
};


export class MutationChangePasswordArgs {
  data: ChangePasswordInput;
};


export class MutationClickBannerArgs {
  data: CreateBannerAccessInput;
};


export class MutationClickDownloadArgs {
  data: CreateDownloadAccessInput;
};


export class MutationClickNewsAccessArgs {
  data: CreateNewsAccessInput;
};


export class MutationCreateAdminArgs {
  data: CreateUserAdminInput;
};


export class MutationCreateBannerArgs {
  data: CreateBannerInput;
};


export class MutationCreateContactArgs {
  data: CreateContactInput;
};


export class MutationCreateDownloadArgs {
  data: CreateDownloadInput;
};


export class MutationCreateNewsArgs {
  data: CreateNewsInput;
};


export class MutationCreateUserArgs {
  data: CreateUserInput;
};


export class MutationDeleteAdminArgs {
  id: Scalars['String'];
};


export class MutationForgotPasswordArgs {
  cpf: Scalars['String'];
};


export class MutationLoginArgs {
  data: AuthInput;
};


export class MutationRemoveBannerArgs {
  id: Scalars['String'];
};


export class MutationRemoveDownloadArgs {
  id: Scalars['String'];
};


export class MutationRemoveNewsArgs {
  id: Scalars['String'];
};


export class MutationResetPasswordArgs {
  data: ResetPasswordInput;
};


export class MutationSelfUpdateUserArgs {
  data: UpdateUserInput;
};


export class MutationUpdateBannerArgs {
  data: UpdateBannerInput;
};


export class MutationUpdateDownloadArgs {
  data: UpdateDownloadInput;
};


export class MutationUpdateNewsArgs {
  data: UpdateNewsInput;
};

export class News {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  end?: Maybe<Scalars['DateTime']>;
  friendlyUrl?: Maybe<Scalars['String']>;
  highlight?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  newsAccess?: Maybe<Array<NewsAccess>>;
  pathImage?: Maybe<Scalars['String']>;
  scheduled: Scalars['Boolean'];
  start?: Maybe<Scalars['DateTime']>;
  text: Scalars['String'];
  title: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export class NewsAccess {
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  news?: Maybe<News>;
  user?: Maybe<User>;
};

export class NewsDashboard {
  title?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Float']>;
};

export class NewsPage {
  currentPage: Scalars['Int'];
  news: Array<News>;
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previousPage: Scalars['Boolean'];
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class Query {
  /** Return total access users */
  accessDashboard: Array<AccessDashboard>;
  /** Return active and total users for profile. */
  activeUsersDashboard: Array<ActiveUsers>;
  banner: Banner;
  /** Return total access banner. */
  bannerDashboard: Array<BannerDashboard>;
  banners: Array<Banner>;
  categoryDownload: Array<CategoryDownload>;
  contact: Contact;
  /** Return total contacts. */
  contactDashboard: Array<ContactCount>;
  contacts: Array<Contact>;
  /** Return User Logged */
  currentUser: User;
  download: Download;
  downloadByCategory: Array<Download>;
  /** Return total access download. */
  downloadDashboard: Array<DownloadDashboard>;
  downloads: Array<Download>;
  homeBanners: Array<Banner>;
  homeNews: NewsPage;
  /** List Admin */
  listUserAdmin: UserPage;
  new: News;
  newByFriendlyUrl: News;
  news: NewsPage;
  /** Return total access news. */
  newsDashboard: Array<NewsDashboard>;
  /** Return total users for resales. */
  resalesDashboard: Array<ResaleCount>;
  searchBanner: BannerPage;
  searchContact: ContactPage;
  searchDownload: DownloadPage;
  searchNews: NewsPage;
  subject: Array<Subject>;
};


export class QueryBannerArgs {
  id: Scalars['String'];
};


export class QueryContactArgs {
  id: Scalars['String'];
};


export class QueryDownloadArgs {
  id: Scalars['String'];
};


export class QueryDownloadByCategoryArgs {
  categoryId: Scalars['String'];
};


export class QueryHomeNewsArgs {
  page: Scalars['Float'];
  type: Scalars['String'];
};


export class QueryListUserAdminArgs {
  data: SearchUserInput;
};


export class QueryNewArgs {
  id: Scalars['String'];
};


export class QueryNewByFriendlyUrlArgs {
  friendlyUrl: Scalars['String'];
};


export class QueryNewsArgs {
  page: Scalars['Float'];
  type: Scalars['String'];
};


export class QuerySearchBannerArgs {
  data: SearchBannerInput;
};


export class QuerySearchContactArgs {
  data: SearchContactInput;
};


export class QuerySearchDownloadArgs {
  data: SearchDownloadInput;
};


export class QuerySearchNewsArgs {
  data: SearchNewsInput;
};

export class ResaleCount {
  name: Scalars['String'];
  region: Scalars['String'];
  total: Scalars['Float'];
};

export class ResetPasswordInput {
  code: Scalars['String'];
  newPassword: Scalars['String'];
};

export class SearchBannerInput {
  end: Scalars['DateTime'];
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  start: Scalars['DateTime'];
};

export class SearchContactInput {
  email?: InputMaybe<Scalars['String']>;
  end: Scalars['DateTime'];
  name?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  start: Scalars['DateTime'];
  status?: InputMaybe<Scalars['String']>;
};

export class SearchDownloadInput {
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
};

export class SearchNewsInput {
  end: Scalars['DateTime'];
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  start: Scalars['DateTime'];
  /** ENUM news|case|article */
  type: Scalars['String'];
};

export class SearchUserInput {
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export class Subject {
  createdAt: Scalars['DateTime'];
  deletedAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  subjectContato?: Maybe<Array<Contact>>;
};

export class TokenDto {
  token: Scalars['String'];
  user: User;
};

export class UpdateBannerInput {
  end?: InputMaybe<Scalars['DateTime']>;
  highlight?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  pathImage?: InputMaybe<Scalars['String']>;
  pathLink?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Float']>;
  scheduled?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
};

export class UpdateDownloadInput {
  categoryId?: InputMaybe<Scalars['String']>;
  extension?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  profile?: InputMaybe<Scalars['String']>;
};

export class UpdateNewsInput {
  /** Description news */
  description?: InputMaybe<Scalars['String']>;
  /** Schedule date end */
  end?: InputMaybe<Scalars['DateTime']>;
  highlight?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  /** PathImage news */
  pathImage?: InputMaybe<Scalars['String']>;
  /** Schedule news */
  scheduled: Scalars['Boolean'];
  /** Schedule date start */
  start?: InputMaybe<Scalars['DateTime']>;
  /** Text news */
  text?: InputMaybe<Scalars['String']>;
  /** Title news */
  title: Scalars['String'];
  /** ENUM news|case|article */
  type: Scalars['String'];
};

export class UpdateUserInput {
  birthday?: InputMaybe<Scalars['String']>;
  cpf?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  jobRole?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export class User {
  access?: Maybe<Array<UserAccess>>;
  birthday?: Maybe<Scalars['String']>;
  cpf?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedById?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  jobRole?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pathImage?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  resetPasswordExpiration?: Maybe<Scalars['DateTime']>;
  type: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export class UserAccess {
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  user: User;
};

export class UserPage {
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previousPage: Scalars['Boolean'];
  results?: Maybe<Array<User>>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export type UserFragment = { id: string, name?: string | null, email?: string | null, cpf?: string | null, birthday?: string | null, phone?: string | null, pathImage?: string | null };

export type DefaultMessageFragment = { message: string, status: number };

export type BannerPageFragment = { totalCount: number, pageSize: number, previousPage: boolean, currentPage: number, totalPage: number, nextPage: boolean, banner: Array<{ id: string, title: string, pathImage?: string | null, pathLink?: string | null, highlight?: boolean | null, profile?: string | null, scheduled: boolean, start?: any | null, position: number, end?: any | null, createdAt: any, bannerAccess?: Array<{ id: string }> | null }> };

export type BannerFragment = { id: string, title: string, pathImage?: string | null, pathLink?: string | null, highlight?: boolean | null, profile?: string | null, scheduled: boolean, start?: any | null, position: number, end?: any | null, createdAt: any, bannerAccess?: Array<{ id: string }> | null };

export type NewsPageFragment = { totalCount: number, pageSize: number, currentPage: number, totalPage: number, nextPage: boolean, news: Array<{ id: string, title: string, text: string, description: string, pathImage?: string | null, highlight?: boolean | null, scheduled: boolean, start?: any | null, end?: any | null, type: string, createdAt: any, friendlyUrl?: string | null, newsAccess?: Array<{ id: string, createdAt: any, news?: { id: string } | null, user?: { id: string, name?: string | null, email?: string | null, cpf?: string | null, birthday?: string | null, phone?: string | null, pathImage?: string | null } | null }> | null }> };

export type NewsFragment = { id: string, title: string, text: string, description: string, pathImage?: string | null, highlight?: boolean | null, scheduled: boolean, start?: any | null, end?: any | null, type: string, createdAt: any, friendlyUrl?: string | null, newsAccess?: Array<{ id: string, createdAt: any, news?: { id: string } | null, user?: { id: string, name?: string | null, email?: string | null, cpf?: string | null, birthday?: string | null, phone?: string | null, pathImage?: string | null } | null }> | null };

export type DownloadPageFragment = { totalCount: number, pageSize: number, currentPage: number, totalPage: number, nextPage: boolean, downloads: Array<{ id: string, name: string, path?: string | null, profile: string, createdAt: any, extension?: string | null, category?: { id: string, name: string } | null, downloadAccess?: Array<{ id: string }> | null }> };

export type DownloadFragment = { id: string, name: string, path?: string | null, profile: string, createdAt: any, extension?: string | null, category?: { id: string, name: string } | null, downloadAccess?: Array<{ id: string }> | null };

export type CreateBannerMutationVariables = Exact<{
  input: CreateBannerInput;
}>;


export type CreateBannerMutation = { createBanner: { id: string, title: string, pathImage?: string | null, pathLink?: string | null, highlight?: boolean | null, profile?: string | null, scheduled: boolean, start?: any | null, position: number, end?: any | null, createdAt: any, bannerAccess?: Array<{ id: string }> | null } };

export type RemoveBannerMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveBannerMutation = { removeBanner: { message: string, status: number } };

export type UpdateBannerMutationVariables = Exact<{
  input: UpdateBannerInput;
}>;


export type UpdateBannerMutation = { updateBanner: { id: string } };

export type SearchBannerQueryVariables = Exact<{
  input: SearchBannerInput;
}>;


export type SearchBannerQuery = { searchBanner: { totalCount: number, pageSize: number, previousPage: boolean, currentPage: number, totalPage: number, nextPage: boolean, banner: Array<{ id: string, title: string, pathImage?: string | null, pathLink?: string | null, highlight?: boolean | null, profile?: string | null, scheduled: boolean, start?: any | null, position: number, end?: any | null, createdAt: any, bannerAccess?: Array<{ id: string }> | null }> } };

export type GetBannerByIdQueryVariables = Exact<{
  input: Scalars['String'];
}>;


export type GetBannerByIdQuery = { banner: { id: string, title: string, pathImage?: string | null, pathLink?: string | null, highlight?: boolean | null, profile?: string | null, scheduled: boolean, start?: any | null, position: number, end?: any | null, createdAt: any, bannerAccess?: Array<{ id: string }> | null } };

export type GetCategoryDownloadQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCategoryDownloadQuery = { categoryDownload: Array<{ id: string, name: string }> };

export type SearchContactQueryVariables = Exact<{
  input: SearchContactInput;
}>;


export type SearchContactQuery = { searchContact: { pageSize: number, previousPage: boolean, currentPage: number, nextPage: boolean, totalCount: number, contact: Array<{ id: string, answer?: string | null, answeredAt?: any | null, createdAt: any, email: string, message: string, name: string, phone: string, subject: { id: string, name: string, createdAt: any } }> } };

export type AccessDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type AccessDashboardQuery = { accessDashboard: Array<{ createdAt: string, total: number }> };

export type ActiveUsersDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveUsersDashboardQuery = { activeUsersDashboard: Array<{ total: number, name: string }> };

export type ResalesDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type ResalesDashboardQuery = { resalesDashboard: Array<{ name: string, region: string, total: number }> };

export type ContactDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactDashboardQuery = { contactDashboard: Array<{ total: number, noAnswered: number }> };

export type NewsDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type NewsDashboardQuery = { newsDashboard: Array<{ title?: string | null, total?: number | null }> };

export type CreateDownloadMutationVariables = Exact<{
  input: CreateDownloadInput;
}>;


export type CreateDownloadMutation = { createDownload: { id: string, name: string, path?: string | null, profile: string, createdAt: any } };

export type RemoveDownloadMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveDownloadMutation = { removeDownload: { message: string, status: number } };

export type UpdateDownloadMutationVariables = Exact<{
  input: UpdateDownloadInput;
}>;


export type UpdateDownloadMutation = { updateDownload: { id: string, name: string, path?: string | null, profile: string, extension?: string | null } };

export type SearchDownloadQueryVariables = Exact<{
  input: SearchDownloadInput;
}>;


export type SearchDownloadQuery = { searchDownload: { totalCount: number, pageSize: number, currentPage: number, totalPage: number, nextPage: boolean, downloads: Array<{ id: string, name: string, path?: string | null, profile: string, createdAt: any, extension?: string | null, category?: { id: string, name: string } | null, downloadAccess?: Array<{ id: string }> | null }> } };

export type GetDownloadByIdQueryVariables = Exact<{
  input: Scalars['String'];
}>;


export type GetDownloadByIdQuery = { download: { id: string, name: string, path?: string | null, profile: string, extension?: string | null, category?: { id: string, name: string } | null } };

export type LoginMutationVariables = Exact<{
  input: AuthInput;
}>;


export type LoginMutation = { login: { token: string, user: { id: string, name?: string | null, email?: string | null, cpf?: string | null, birthday?: string | null, phone?: string | null, pathImage?: string | null } } };

export type CreateNewsMutationVariables = Exact<{
  input: CreateNewsInput;
}>;


export type CreateNewsMutation = { createNews: { id: string, title: string, text: string, description: string, pathImage?: string | null, highlight?: boolean | null, scheduled: boolean, start?: any | null, end?: any | null, type: string, createdAt: any, friendlyUrl?: string | null, newsAccess?: Array<{ id: string, createdAt: any, news?: { id: string } | null, user?: { id: string, name?: string | null, email?: string | null, cpf?: string | null, birthday?: string | null, phone?: string | null, pathImage?: string | null } | null }> | null } };

export type UpdateNewsMutationVariables = Exact<{
  input: UpdateNewsInput;
}>;


export type UpdateNewsMutation = { updateNews: { id: string, title: string, text: string, description: string, pathImage?: string | null, highlight?: boolean | null, scheduled: boolean, start?: any | null, end?: any | null, type: string, createdAt: any, friendlyUrl?: string | null, newsAccess?: Array<{ id: string, createdAt: any, news?: { id: string } | null, user?: { id: string, name?: string | null, email?: string | null, cpf?: string | null, birthday?: string | null, phone?: string | null, pathImage?: string | null } | null }> | null } };

export type RemoveNewsMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveNewsMutation = { removeNews: { message: string, status: number } };

export type SearchNewsQueryVariables = Exact<{
  input: SearchNewsInput;
}>;


export type SearchNewsQuery = { searchNews: { totalCount: number, pageSize: number, currentPage: number, totalPage: number, nextPage: boolean, news: Array<{ id: string, title: string, text: string, description: string, pathImage?: string | null, highlight?: boolean | null, scheduled: boolean, start?: any | null, end?: any | null, type: string, createdAt: any, friendlyUrl?: string | null, newsAccess?: Array<{ id: string, createdAt: any, news?: { id: string } | null, user?: { id: string, name?: string | null, email?: string | null, cpf?: string | null, birthday?: string | null, phone?: string | null, pathImage?: string | null } | null }> | null }> } };

export type GetNewByIdQueryVariables = Exact<{
  input: Scalars['String'];
}>;


export type GetNewByIdQuery = { new: { id: string, title: string, text: string, description: string, pathImage?: string | null, highlight?: boolean | null, scheduled: boolean, start?: any | null, end?: any | null, type: string, createdAt: any, friendlyUrl?: string | null, newsAccess?: Array<{ id: string, createdAt: any, news?: { id: string } | null, user?: { id: string, name?: string | null, email?: string | null, cpf?: string | null, birthday?: string | null, phone?: string | null, pathImage?: string | null } | null }> | null } };

export type BannerDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type BannerDashboardQuery = { bannerDashboard: Array<{ title?: string | null, total?: number | null }> };

export type DownloadDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type DownloadDashboardQuery = { downloadDashboard: Array<{ name?: string | null, total?: number | null }> };

export const DefaultMessageFragmentDoc = gql`
    fragment DefaultMessage on DefaultMessage {
  message
  status
}
    `;
export const BannerFragmentDoc = gql`
    fragment Banner on Banner {
  id
  title
  pathImage
  pathLink
  highlight
  profile
  scheduled
  start
  position
  end
  createdAt
  bannerAccess {
    id
  }
}
    `;
export const BannerPageFragmentDoc = gql`
    fragment BannerPage on BannerPage {
  totalCount
  pageSize
  previousPage
  currentPage
  totalPage
  nextPage
  banner {
    ...Banner
  }
}
    ${BannerFragmentDoc}`;
export const UserFragmentDoc = gql`
    fragment User on User {
  id
  name
  email
  cpf
  birthday
  phone
  pathImage
}
    `;
export const NewsFragmentDoc = gql`
    fragment News on News {
  id
  title
  text
  description
  pathImage
  highlight
  scheduled
  start
  end
  type
  createdAt
  friendlyUrl
  newsAccess {
    id
    news {
      id
    }
    user {
      ...User
    }
    createdAt
  }
}
    ${UserFragmentDoc}`;
export const NewsPageFragmentDoc = gql`
    fragment NewsPage on NewsPage {
  totalCount
  pageSize
  currentPage
  totalPage
  nextPage
  news {
    ...News
  }
}
    ${NewsFragmentDoc}`;
export const DownloadFragmentDoc = gql`
    fragment Download on Download {
  id
  name
  path
  profile
  createdAt
  extension
  category {
    id
    name
  }
  downloadAccess {
    id
  }
}
    `;
export const DownloadPageFragmentDoc = gql`
    fragment DownloadPage on DownloadPage {
  totalCount
  pageSize
  currentPage
  totalPage
  nextPage
  downloads {
    ...Download
  }
}
    ${DownloadFragmentDoc}`;
export const CreateBannerDocument = gql`
    mutation CreateBanner($input: CreateBannerInput!) {
  createBanner(data: $input) {
    ...Banner
  }
}
    ${BannerFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateBannerGQL extends Apollo.Mutation<CreateBannerMutation, CreateBannerMutationVariables> {
    document = CreateBannerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveBannerDocument = gql`
    mutation RemoveBanner($id: String!) {
  removeBanner(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveBannerGQL extends Apollo.Mutation<RemoveBannerMutation, RemoveBannerMutationVariables> {
    document = RemoveBannerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateBannerDocument = gql`
    mutation UpdateBanner($input: UpdateBannerInput!) {
  updateBanner(data: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateBannerGQL extends Apollo.Mutation<UpdateBannerMutation, UpdateBannerMutationVariables> {
    document = UpdateBannerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchBannerDocument = gql`
    query SearchBanner($input: SearchBannerInput!) {
  searchBanner(data: $input) {
    ...BannerPage
  }
}
    ${BannerPageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchBannerGQL extends Apollo.Query<SearchBannerQuery, SearchBannerQueryVariables> {
    document = SearchBannerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBannerByIdDocument = gql`
    query GetBannerById($input: String!) {
  banner(id: $input) {
    ...Banner
  }
}
    ${BannerFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBannerByIdGQL extends Apollo.Query<GetBannerByIdQuery, GetBannerByIdQueryVariables> {
    document = GetBannerByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCategoryDownloadDocument = gql`
    query GetCategoryDownload {
  categoryDownload {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCategoryDownloadGQL extends Apollo.Query<GetCategoryDownloadQuery, GetCategoryDownloadQueryVariables> {
    document = GetCategoryDownloadDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchContactDocument = gql`
    query SearchContact($input: SearchContactInput!) {
  searchContact(data: $input) {
    pageSize
    previousPage
    currentPage
    nextPage
    totalCount
    contact {
      id
      answer
      answeredAt
      createdAt
      email
      message
      name
      phone
      subject {
        id
        name
        createdAt
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchContactGQL extends Apollo.Query<SearchContactQuery, SearchContactQueryVariables> {
    document = SearchContactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AccessDashboardDocument = gql`
    query AccessDashboard {
  accessDashboard {
    createdAt
    total
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AccessDashboardGQL extends Apollo.Query<AccessDashboardQuery, AccessDashboardQueryVariables> {
    document = AccessDashboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ActiveUsersDashboardDocument = gql`
    query ActiveUsersDashboard {
  activeUsersDashboard {
    total
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ActiveUsersDashboardGQL extends Apollo.Query<ActiveUsersDashboardQuery, ActiveUsersDashboardQueryVariables> {
    document = ActiveUsersDashboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResalesDashboardDocument = gql`
    query ResalesDashboard {
  resalesDashboard {
    name
    region
    total
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResalesDashboardGQL extends Apollo.Query<ResalesDashboardQuery, ResalesDashboardQueryVariables> {
    document = ResalesDashboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ContactDashboardDocument = gql`
    query ContactDashboard {
  contactDashboard {
    total
    noAnswered
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ContactDashboardGQL extends Apollo.Query<ContactDashboardQuery, ContactDashboardQueryVariables> {
    document = ContactDashboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NewsDashboardDocument = gql`
    query NewsDashboard {
  newsDashboard {
    title
    total
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NewsDashboardGQL extends Apollo.Query<NewsDashboardQuery, NewsDashboardQueryVariables> {
    document = NewsDashboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDownloadDocument = gql`
    mutation CreateDownload($input: CreateDownloadInput!) {
  createDownload(data: $input) {
    id
    name
    path
    profile
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDownloadGQL extends Apollo.Mutation<CreateDownloadMutation, CreateDownloadMutationVariables> {
    document = CreateDownloadDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveDownloadDocument = gql`
    mutation RemoveDownload($id: String!) {
  removeDownload(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveDownloadGQL extends Apollo.Mutation<RemoveDownloadMutation, RemoveDownloadMutationVariables> {
    document = RemoveDownloadDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDownloadDocument = gql`
    mutation UpdateDownload($input: UpdateDownloadInput!) {
  updateDownload(data: $input) {
    id
    name
    path
    profile
    extension
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDownloadGQL extends Apollo.Mutation<UpdateDownloadMutation, UpdateDownloadMutationVariables> {
    document = UpdateDownloadDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchDownloadDocument = gql`
    query SearchDownload($input: SearchDownloadInput!) {
  searchDownload(data: $input) {
    ...DownloadPage
  }
}
    ${DownloadPageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchDownloadGQL extends Apollo.Query<SearchDownloadQuery, SearchDownloadQueryVariables> {
    document = SearchDownloadDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDownloadByIdDocument = gql`
    query GetDownloadById($input: String!) {
  download(id: $input) {
    id
    name
    path
    profile
    extension
    category {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDownloadByIdGQL extends Apollo.Query<GetDownloadByIdQuery, GetDownloadByIdQueryVariables> {
    document = GetDownloadByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoginDocument = gql`
    mutation Login($input: AuthInput!) {
  login(data: $input) {
    user {
      ...User
    }
    token
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoginGQL extends Apollo.Mutation<LoginMutation, LoginMutationVariables> {
    document = LoginDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateNewsDocument = gql`
    mutation CreateNews($input: CreateNewsInput!) {
  createNews(data: $input) {
    ...News
  }
}
    ${NewsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateNewsGQL extends Apollo.Mutation<CreateNewsMutation, CreateNewsMutationVariables> {
    document = CreateNewsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateNewsDocument = gql`
    mutation UpdateNews($input: UpdateNewsInput!) {
  updateNews(data: $input) {
    ...News
  }
}
    ${NewsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateNewsGQL extends Apollo.Mutation<UpdateNewsMutation, UpdateNewsMutationVariables> {
    document = UpdateNewsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveNewsDocument = gql`
    mutation RemoveNews($id: String!) {
  removeNews(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveNewsGQL extends Apollo.Mutation<RemoveNewsMutation, RemoveNewsMutationVariables> {
    document = RemoveNewsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchNewsDocument = gql`
    query SearchNews($input: SearchNewsInput!) {
  searchNews(data: $input) {
    ...NewsPage
  }
}
    ${NewsPageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchNewsGQL extends Apollo.Query<SearchNewsQuery, SearchNewsQueryVariables> {
    document = SearchNewsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNewByIdDocument = gql`
    query GetNewById($input: String!) {
  new(id: $input) {
    ...News
  }
}
    ${NewsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNewByIdGQL extends Apollo.Query<GetNewByIdQuery, GetNewByIdQueryVariables> {
    document = GetNewByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BannerDashboardDocument = gql`
    query BannerDashboard {
  bannerDashboard {
    title
    total
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BannerDashboardGQL extends Apollo.Query<BannerDashboardQuery, BannerDashboardQueryVariables> {
    document = BannerDashboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DownloadDashboardDocument = gql`
    query DownloadDashboard {
  downloadDashboard {
    name
    total
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DownloadDashboardGQL extends Apollo.Query<DownloadDashboardQuery, DownloadDashboardQueryVariables> {
    document = DownloadDashboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }